import dynamic from 'next/dynamic';

export default dynamic(() => import('./core/components/chat'), {
    ssr: false,
});
